import React from 'react';

import './Footer.scss';

const Footer = () => {
  return (
   <footer className="footer">
        <p>Editorial Pedagogía Interactiva © 2026</p>
      </footer>
  )
}

export default Footer